import { render, staticRenderFns } from "./busMainR.vue?vue&type=template&id=146245a1&scoped=true&"
import script from "./busMainR.vue?vue&type=script&lang=js&"
export * from "./busMainR.vue?vue&type=script&lang=js&"
import style0 from "./busMainR.vue?vue&type=style&index=0&id=146245a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146245a1",
  null
  
)

export default component.exports